import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, CheckIcon, ArrowRightIcon } from 'lucide-react';
const options = [{
  name: 'MEGA PACK',
  emoji: '📘',
  description: '24 sesiones + registros + bonos',
  oldPrice: '$49.990',
  price: '$19.990',
  link: 'https://fonocheck.librosdigitales.pro/cart/44768212975752:1',
  ctaText: 'SÍ, QUIERO EL MEGA PACK →',
  badge: null,
  includes: ['24 sesiones estructuradas', 'Registros clínicos claros', 'Tareas para casa', 'Planillas de seguimiento', 'Adaptaciones TEA, TDAH, ansiedad', '3 Bonos estratégicos', 'Acceso inmediato', 'Formato PDF descargable']
}, {
  name: 'MEGA PACK + ANTIDISPERSIÓN',
  emoji: '🧠',
  description: '24 sesiones + 20 fichas de foco + bonos',
  oldPrice: '$54.980',
  price: '$24.980',
  link: 'https://fonocheck.librosdigitales.pro/cart/44780558549128:1',
  ctaText: 'SÍ, QUIERO MEGA PACK + ANTIDISPERSIÓN →',
  badge: null,
  includes: ['24 sesiones estructuradas', 'Registros clínicos claros', 'Tareas para casa', 'Planillas de seguimiento', 'Adaptaciones TEA, TDAH, ansiedad', '3 Bonos estratégicos', 'Acceso inmediato', 'Formato PDF descargable', 'Sistema Antidispersión Clínica™', '20 fichas de recuperación de foco']
}, {
  name: 'MEGA PACK + CRISIS EN SESIÓN',
  emoji: '🚨',
  description: '24 sesiones + 20 fichas de crisis + bonos',
  oldPrice: '$54.980',
  price: '$24.980',
  link: 'https://fonocheck.librosdigitales.pro/cart/44780566216840:1',
  ctaText: 'SÍ, QUIERO MEGA PACK + CRISIS →',
  badge: null,
  includes: ['24 sesiones estructuradas', 'Registros clínicos claros', 'Tareas para casa', 'Planillas de seguimiento', 'Adaptaciones TEA, TDAH, ansiedad', '3 Bonos estratégicos', 'Acceso inmediato', 'Formato PDF descargable', 'Protocolo Crisis en Sesión™', '20 fichas paso a paso para crisis']
}, {
  name: 'COMBO COMPLETO',
  emoji: '🏆',
  description: '24 sesiones + 40 fichas clínicas + bonos',
  oldPrice: '$58.990',
  price: '$28.990',
  link: 'https://fonocheck.librosdigitales.pro/cart/44780568903816:1',
  ctaText: 'SÍ, QUIERO EL COMBO COMPLETO →',
  badge: '⭐ MÁS ELEGIDO',
  includes: ['24 sesiones estructuradas', 'Registros clínicos claros', 'Tareas para casa', 'Planillas de seguimiento', 'Adaptaciones TEA, TDAH, ansiedad', '3 Bonos estratégicos', 'Acceso inmediato', 'Formato PDF descargable', 'Sistema Antidispersión Clínica™', 'Protocolo Crisis en Sesión™', '40 fichas clínicas en total']
}];
export function PurchaseSection() {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const selectedOption = options[selectedIndex];
  return <section id="compra" className="py-20 bg-[#EDF2F7]" data-id="element-104">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-105">
        {/* Not for you / For you */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-20" data-id="element-106">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-xl border-l-4 border-gray-300 shadow-sm" data-id="element-107">
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-108">
              ESTO NO ES PARA VOS SI…
            </h3>
            <ul className="space-y-3 text-gray-600" data-id="element-109">
              <li className="flex items-start gap-2" data-id="element-110">
                <span className="text-red-500 font-bold" data-id="element-111">✕</span> Buscás
                actividades sueltas
              </li>
              <li className="flex items-start gap-2" data-id="element-112">
                <span className="text-red-500 font-bold" data-id="element-113">✕</span> Querés recetas
                cerradas
              </li>
              <li className="flex items-start gap-2" data-id="element-114">
                <span className="text-red-500 font-bold" data-id="element-115">✕</span> No te importa
                registrar procesos
              </li>
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-xl border-l-4 border-[#1B3A5C] shadow-sm" data-id="element-116">
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-117">
              👉 SÍ ES PARA VOS SI...
            </h3>
            <p className="text-lg text-gray-700 font-medium" data-id="element-118">
              Querés trabajar con orden, criterio y tranquilidad profesional.
            </p>
          </motion.div>
        </div>

        {/* Guarantee */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-xl p-8 mb-16 text-center border border-gray-100 shadow-sm max-w-2xl mx-auto" data-id="element-119">
          <ShieldCheckIcon className="w-12 h-12 text-[#1B3A5C] mx-auto mb-4" data-id="element-120" />
          <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-121">
            GARANTÍA 7 DÍAS
          </h3>
          <p className="text-gray-600 mb-4" data-id="element-122">
            Probalo. Si no sentís más orden, claridad y seguridad clínica, te
            devolvemos el 100%.
          </p>
          <p className="font-bold text-[#1B3A5C]" data-id="element-123">El riesgo es nuestro.</p>
        </motion.div>

        {/* Unified Pricing Selector */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gray-900 rounded-2xl shadow-2xl overflow-hidden border border-gray-800" data-id="element-124">
          <div className="p-6 md:p-10" data-id="element-125">
            <div className="text-center mb-8" data-id="element-126">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-2" data-id="element-127">
                Elegí tu <span className="text-[#C9A84C]" data-id="element-128">PACK:</span>
              </h2>
              <p className="text-gray-400" data-id="element-129">
                Todas las opciones incluyen los 3 bonos estratégicos
              </p>
            </div>

            <div className="space-y-4 mb-8" data-id="element-130">
              {options.map((option, index) => {
              const isSelected = selectedIndex === index;
              return <div key={index} onClick={() => setSelectedIndex(index)} className={`relative flex items-center justify-between p-4 md:p-5 rounded-xl cursor-pointer transition-all duration-200 border-2 ${isSelected ? 'border-[#C9A84C] bg-gray-800/80 shadow-[0_0_15px_rgba(201,168,76,0.15)]' : 'border-gray-700 bg-gray-800/30 hover:border-gray-600 hover:bg-gray-800/50'}`} data-id="element-131">
                    <div className="flex items-center gap-4" data-id="element-132">
                      {/* Radio Circle */}
                      <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-colors ${isSelected ? 'border-[#C9A84C]' : 'border-gray-500'}`} data-id="element-133">
                        {isSelected && <div className="w-3 h-3 rounded-full bg-[#C9A84C]" data-id="element-134" />}
                      </div>

                      <div data-id="element-135">
                        <div className="flex items-center gap-2 mb-0.5" data-id="element-136">
                          <span className="text-xl" data-id="element-137">{option.emoji}</span>
                          <h3 className="text-white font-bold text-sm md:text-base" data-id="element-138">
                            {option.name}
                          </h3>
                          {option.badge && <span className="hidden sm:inline-block bg-blue-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider" data-id="element-139">
                              {option.badge}
                            </span>}
                        </div>
                        {option.badge && <span className="sm:hidden inline-block bg-blue-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider mb-1" data-id="element-140">
                            {option.badge}
                          </span>}
                        <p className="text-gray-400 text-xs md:text-sm" data-id="element-141">
                          {option.description}
                        </p>
                      </div>
                    </div>

                    <div className="text-right pl-4" data-id="element-142">
                      <p className="text-gray-500 line-through text-xs md:text-sm" data-id="element-143">
                        {option.oldPrice}
                      </p>
                      <p className="text-white font-bold text-lg md:text-2xl" data-id="element-144">
                        {option.price}
                      </p>
                    </div>
                  </div>;
            })}
            </div>

            {/* CTA Button */}
            <motion.a href={selectedOption.link} target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} animate={{
            boxShadow: ['0 0 0 0 rgba(34, 197, 94, 0.4)', '0 0 0 15px rgba(34, 197, 94, 0)']
          }} transition={{
            boxShadow: {
              repeat: Infinity,
              duration: 1.5
            }
          }} className="block w-full bg-[#22C55E] text-white py-4 md:py-5 rounded-xl font-bold text-lg md:text-xl text-center shadow-lg hover:bg-[#16A34A] transition-colors mb-4 no-underline" data-id="element-145">
              {selectedOption.ctaText}
            </motion.a>

            <p className="text-center text-gray-500 italic text-sm mb-10" data-id="element-146">
              Podés sumar otro recurso cuando quieras
            </p>

            {/* Includes Section */}
            <div className="bg-gray-800/50 rounded-xl p-6 md:p-8 border border-gray-700/50" data-id="element-147">
              <h4 className="text-gray-400 font-bold text-sm tracking-widest uppercase mb-6" data-id="element-148">
                TU PACK INCLUYE:
              </h4>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-4 gap-x-6" data-id="element-149">
                {selectedOption.includes.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-150">
                    <CheckIcon className="w-5 h-5 text-blue-400 flex-shrink-0 mt-0.5" data-id="element-151" />
                    <span className="text-gray-300 text-sm" data-id="element-152">{item}</span>
                  </div>)}
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}